import { render, staticRenderFns } from "./RatingStats.two.vue?vue&type=template&id=3405f7ec"
import script from "./RatingStats.two.vue?vue&type=script&lang=js"
export * from "./RatingStats.two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports